import {GraphQLClient} from 'graphql-request';
import {USER_STATE_GRAPHQL_HOST} from '../../constants/app';
import getMemberToken from '../../utils/getMemberToken';

const USER_STATE_GRAPHQL_ENDPOINT = `${USER_STATE_GRAPHQL_HOST}`;

const userStateGraphQLClient = new GraphQLClient(USER_STATE_GRAPHQL_ENDPOINT, {
  headers: {
    'Content-Type': 'application/json',
    'membership-session-token': getMemberToken(),
    'tkww-application': 'fe-member-registry',
  },
});

export default userStateGraphQLClient;
